import {on} from './util/event'
import {events} from './events';
import userSubscription from './userSubscription';
import article from "./article";

const econtentaClickHandler = function(value) {
  console.log(value);
  if (window.withMfPixel && ('econtenta' in window)) {
    try {
      window.econtenta.track({
        action: 'click',
        action_value: {
          value: value
        }
      });

      if ('sessionStorage' in window) {
        sessionStorage.setItem('econtentaClickValue', value);
      }
    } catch (e) {
      console.error(e)
    }
  }
};

on(events.LAYOUT_tryAuth, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'LAYOUT_tryAuth',
    transport: 'beacon'
  });

  econtentaClickHandler('LAYOUT_tryAuth');

  ('ym' in window) && ym(53185591, 'reachGoal', 'auth1');
});

on(events.LAYOUT_trySubscribeWithoutAuth, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'LAYOUT_trySubscribeWithoutAuth',
    transport: 'beacon'
  });

  econtentaClickHandler('LAYOUT_trySubscribeWithoutAuth');

  ('ym' in window) && ym(53185591, 'reachGoal', 'subscribe');
});

on(events.LAYOUT_trySubscribeWithAuth, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'LAYOUT_trySubscribeWithAuth',
    transport: 'beacon'
  });

  econtentaClickHandler('LAYOUT_trySubscribeWithAuth');

  ('ym' in window) && ym(53185591, 'reachGoal', 'subscribe');
});

on(events.ARTICLE_tryAuth, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'ARTICLE_tryAuth',
    transport: 'beacon'
  });

  econtentaClickHandler('ARTICLE_tryAuth');

  ('ym' in window) && ym(53185591, 'reachGoal', 'auth2');
});
on(events.ARTICLE_tryAuthVk, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'ARTICLE_tryAuthVk',
    transport: 'beacon'
  });

  econtentaClickHandler('ARTICLE_tryAuthVk');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authvk');
});
on(events.ARTICLE_tryAuthGp, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'ARTICLE_tryAuthGp',
    transport: 'beacon'
  });

  econtentaClickHandler('ARTICLE_tryAuthGp');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authgoogle');
});
on(events.ARTICLE_tryAuthFb, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'ARTICLE_tryAuthFb',
    transport: 'beacon'
  });

  econtentaClickHandler('ARTICLE_tryAuthFb');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authfb');
});

on(events.ARTICLE_trySubscribeWithAuth, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'ARTICLE_trySubscribeWithAuth',
    transport: 'beacon'
  });

  econtentaClickHandler('ARTICLE_trySubscribeWithAuth');

  ('ym' in window) && ym(53185591, 'reachGoal', 'subscribe');
});

on(events.AUTH_MODAL_tryAuthVk, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'AUTH_MODAL_tryAuthVk',
    transport: 'beacon'
  });

  econtentaClickHandler('AUTH_MODAL_tryAuthVk');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authvk');
});
on(events.AUTH_MODAL_tryAuthGp, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'AUTH_MODAL_tryAuthGp',
    transport: 'beacon'
  });

  econtentaClickHandler('AUTH_MODAL_tryAuthGp');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authgoogle');
});
on(events.AUTH_MODAL_tryAuthFb, e => {
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'AUTH_MODAL_tryAuthFb',
    transport: 'beacon'
  });

  econtentaClickHandler('AUTH_MODAL_tryAuthFb');

  ('ym' in window) && ym(53185591, 'reachGoal', 'authfb');
});

on('submitLogin_from_mfLoginNotification.kiosk.AUTH_MODAL', e => econtentaClickHandler('submitLogin_from_mfLoginNotification.kiosk.AUTH_MODAL'));
on('tryAuthVk_from_mfLoginNotification.kiosk.AUTH_MODAL', e => econtentaClickHandler('tryAuthVk_from_mfLoginNotification.kiosk.AUTH_MODAL'));
on('tryAuthFb_from_mfLoginNotification.kiosk.AUTH_MODAL', e => econtentaClickHandler('tryAuthFb_from_mfLoginNotification.kiosk.AUTH_MODAL'));
on('tryAuthGp_from_mfLoginNotification.kiosk.AUTH_MODAL', e => econtentaClickHandler('tryAuthGp_from_mfLoginNotification.kiosk.AUTH_MODAL'));

on('submitSubscribe.kiosk.SUBSCRIBE_MODAL', e => econtentaClickHandler('submitSubscribe.kiosk.SUBSCRIBE_MODAL'));
on('submitSubscribe_from_mfSubscribeNotification.kiosk.SUBSCRIBE_MODAL', e => econtentaClickHandler('submitSubscribe_from_mfSubscribeNotification.kiosk.SUBSCRIBE_MODAL'));

on(events.DOWNLOAD_APP_MODAL_tryIos, e => {
  econtentaClickHandler('DOWNLOAD_APP_MODAL_tryIos');

  ('ym' in window) && ym(53185591, 'reachGoal', 'appmf');
});
on(events.DOWNLOAD_APP_MODAL_tryAndroid, e => {
  econtentaClickHandler('DOWNLOAD_APP_MODAL_tryAndroid');

  ('ym' in window) && ym(53185591, 'reachGoal', 'appmf');
});

on(events.REGISTRATION_success, e => {
  var userId = null;
  if (e && e.detail && e.detail.user_id) {
    userId = e.detail.user_id;
  }

  var valueLog = null;
  if ('sessionStorage' in window) {
    valueLog = sessionStorage.getItem('econtentaClickValue');
  }
  var actionValueLog = {user_id: userId};
  if (valueLog) {
    actionValueLog.value = valueLog;
  }
  console.log('complete_registration', actionValueLog);

  if (window.withMfPixel && ('econtenta' in window)) {
    try {
      var value = null;
      if ('sessionStorage' in window) {
        value = sessionStorage.getItem('econtentaClickValue');
      }
      var actionValue = {user_id: userId};
      if (value) {
        actionValue.value = value;
      }

      window.econtenta.track({
        action: 'complete_registration',
        action_value: actionValue
      });
    } catch (e) {
      console.error(e)
    }
  }
});

on(events.LAYOUT_bookmarks, e => {
  console.log('LAYOUT_bookmarks');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-bookmarks',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'bookmarks');
});

on(events.LAYOUT_profile, e => {
  console.log('LAYOUT_profile');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-profile',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'profile');
});

on(events.LAYOUT_magazines, e => {
  console.log('LAYOUT_magazines');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-magazines',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'magazines');
});

on(events.LAYOUT_audio, e => {
  console.log('LAYOUT_audio');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-audio',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'audio');
});

on(events.LAYOUT_appIos, e => {
  console.log('LAYOUT_appIos');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-APP_icon',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'ios');
});

on(events.LAYOUT_appAndroid, e => {
  console.log('LAYOUT_appAndroid');
  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'click',
    eventLabel: 'mf-APP_icon',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'android');
});

on(userSubscription.changeEventName, e => {
  console.log(userSubscription.changeEventName);

  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'submit',
    eventLabel: 'SUCCESS_SUBSCRIBE',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'SUCCESS_SUBSCRIBE');

});

on(article.viewPaywallEvent, e => {
  console.log(article.viewPaywallEvent);

  ('ga' in window) && ga('main.send', 'event', {
    eventCategory: 'CVM',
    eventAction: 'submit',
    eventLabel: 'SUCCESS_SCROLL',
    transport: 'beacon'
  });

  ('ym' in window) && ym(53185591, 'reachGoal', 'SUCCESS_SCROLL');

});

const analytics = {};

export default analytics;
